import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {
  StandingsSeasonsFilterDomainModel
} from "./standings.seasons-filter.domain-model";
import {computed} from "mobx";

export class StandingsSeasonsFilterViewModel extends BaseViewModel {
  domainModel: StandingsSeasonsFilterDomainModel;

  get seasonNum(): Number {
    return this.domainModel.seasonNum;
  }

  get seasonName(): String {
    return this.domainModel.seasonName;
  }

  @computed get name(): String{
    return this.domainModel.seasonName;
  }

  @computed get id(): String{
    return this.domainModel.seasonNum;
  }

  @computed get index(): String{
    return this.domainModel.seasonNum;
  }
}